var React = require('react');

function IconSocialEnvelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35 7.5H5A2.5 2.5 0 002.5 10v20A2.5 2.5 0 005 32.5h30a2.5 2.5 0 002.5-2.5V10A2.5 2.5 0 0035 7.5zM32.25 10L20 18.48 7.75 10h24.5zM5 30V11.14l14.29 9.88a1.25 1.25 0 001.42 0L35 11.14V30H5z","fill":"#B10000"}));
}

IconSocialEnvelope.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 40 40"};

module.exports = IconSocialEnvelope;

IconSocialEnvelope.default = IconSocialEnvelope;
